export const getHolidayMasterList = state => {
    return state.list
}

export const getHolidayMasterDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/holidayMaster/getters.js